<template>
  <v-card>
    <v-card-title class="grey--text text-subtitle-1">
      Prodotti Venduti
      <v-spacer />
      <v-switch
        hide-details
        label="Confronta"
        class="mt-n2"
        inset
        v-model="show_confronta"
      >
      </v-switch>
    </v-card-title>
    <v-card-subtitle class="mt-1">
      <v-row no-gutters align="center">
        <v-col :cols="show_confronta ? 6 : 6" class="pr-2">
          <v-select
            :items="periodi_list"
            v-model="periodo_preset"
            label="Periodo"
            item-value="value"
            item-text="label"
            hide-details
            dense
            outlined
          />
        </v-col>
        <v-col v-if="show_confronta" cols="6" class="pl-2">
          <v-select
            :items="anni_confronto"
            v-model="anno_confronto"
            label="Anno confronto"
            item-value="value"
            item-text="label"
            hide-details
            dense
            outlined
          />
        </v-col>
      </v-row>
      <v-row
        v-if="periodo_preset === null"
        no-gutters
        class="mt-2"
        align="center"
      >
        <v-col cols="6" class="">
          <v-menu
            v-model="picker_inizio"
            :close-on-content-click="false"
            offset-y
            min-width="auto"
          >
            <template #activator="{ on }">
              <v-text-field
                v-model="data_inizio"
                label="Dal"
                prepend-inner-icon="mdi-calendar"
                readonly
                v-on="on"
                hide-details
                dense
                outlined
              />
            </template>
            <v-date-picker
              v-model="data_inizio"
              @input="picker_inizio = false"
            />
          </v-menu>
        </v-col>
        <v-col cols="6" class="pl-2">
          <v-menu
            v-model="picker_fine"
            :close-on-content-click="false"
            offset-y
            min-width="auto"
          >
            <template #activator="{ on }">
              <v-text-field
                v-model="data_fine"
                label="Al"
                prepend-inner-icon="mdi-calendar"
                readonly
                v-on="on"
                hide-details
                dense
                outlined
              />
            </template>
            <v-date-picker
              v-model="data_fine"
              @input="picker_fine = false"
              :min="data_inizio"
            />
          </v-menu>
        </v-col>
      </v-row>
      <v-row no-gutters class="mt-2">
        <v-col cols="4">
          <v-text-field
            v-model="ricerca"
            placeholder="Cerca prodotto..."
            prepend-inner-icon="mdi-magnify"
            hide-details
            dense
            outlined
            clearable
            :error="ricerca_invalida"
          />
        </v-col>
      </v-row>
      <v-row no-gutters class="mt-2 mb-n2 font-weight-medium">
        <v-col :cols="show_confronta ? 4 : 6">Prodotto</v-col>
        <v-col cols="1" class="green--text text--accent-3 d-flex justify-center"
          ># V</v-col
        >
        <v-col cols="1" class="blue--text d-flex justify-center"># B</v-col>
        <v-col cols="2" class="grey--text d-flex justify-center"># Tot</v-col>
        <template v-if="!show_confronta">
          <v-col cols="1" />
          <v-col cols="1" class="d-flex justify-center"># Doc</v-col>
        </template>
        <template v-else>
          <v-col cols="2" class="d-flex justify-center">{{
            anno_confronto
          }}</v-col>
          <v-col cols="2" class="d-flex justify-center">Var %</v-col>
        </template>
      </v-row>
    </v-card-subtitle>
    <v-card-text class="scroll" style="max-height: 350px">
      <template v-if="loading">
        <v-row justify="center" align="center" class="mt-12">
          <v-progress-circular indeterminate width="2" color="green" />
        </v-row>
      </template>
      <template v-else>
        <v-row
          v-if="show_confronta && loading_confronto"
          justify="center"
          class="mt-4 mb-2"
        >
          <v-progress-circular
            indeterminate
            width="2"
            size="18"
            color="blue"
            class="mr-2"
          />
          <span class="text-caption grey--text">Caricamento confronto…</span>
        </v-row>
        <div v-for="(group, gi) in lista_per_sottocategoria" :key="gi">
          <!-- intestazione sottocategoria -->
          <v-row align="center" class="mt-3 mb-1 grey lighten-4 rounded">
            <v-col cols="12" class="d-flex align-center">
              <span class="text-caption grey--text mr-1">{{ group.categoria }}</span>
              <v-icon x-small class="grey--text mr-1">mdi-chevron-right</v-icon>
              <span class="text-caption font-weight-bold primary--text">{{ group.sotto_categoria }}</span>
              <template v-if="show_confronta && group.variazione !== null">
                <v-spacer />
                <v-chip
                  x-small
                  :color="Number(group.variazione) >= 0 ? 'green' : 'red'"
                  dark
                  class="ml-2"
                >
                  {{ Number(group.variazione) >= 0 ? '+' : '' }}{{ group.variazione }} %
                </v-chip>
              </template>
            </v-col>
          </v-row>
          <ProdottoVendutoEl
            v-for="element in group.prodotti"
            :key="element.id"
            :element="element"
            :confronta="show_confronta"
            @select="apriDettaglio(element)"
          />
        </div>
      </template>
    </v-card-text>
    <DialogoProdottoVenduto
      v-model="dialog_dettaglio"
      :element="prodotto_selezionato"
      :show_confronta="show_confronta"
      :anno_confronto="anno_confronto"
      :ts_inizio="ts_inizio"
      :ts_fine="ts_fine"
    />
  </v-card>
</template>

<script>
import moment from "moment";
import _ from "lodash";
import ProdottoVendutoEl from "./prodotto_venduto_element.vue";
import DialogoProdottoVenduto from "./dialogo_prodotto_venduto.vue";
export default {
  components: {
    ProdottoVendutoEl,
    DialogoProdottoVenduto,
  },
  mounted() {
    this.fetch_prodotti();
  },
  watch: {
    periodo_preset(val) {
      if (val !== null) this.onPeriodoChange();
    },
    data_fine(val) {
      if (val && this.data_inizio && this.periodo_preset === null)
        this.onPeriodoChange();
    },
    anno_confronto() {
      if (this.show_confronta) this.fetch_prodotti_confronto();
    },
    show_confronta(val) {
      if (val) this.fetch_prodotti_confronto();
    },
  },
  data() {
    return {
      loading: false,
      loading_confronto: false,
      ricerca: "",
      dialog_dettaglio: false,
      prodotto_selezionato: null,
      show_confronta: false,
      periodo_preset: 0,
      data_inizio: null,
      data_fine: null,
      picker_inizio: false,
      picker_fine: false,
      anno_confronto: moment().year() - 1,
      periodi_list: [
        { label: "Ultima settimana", value: 7 },
        { label: "Ultimo mese", value: 30 },
        { label: "Ultimi 3 mesi", value: 90 },
        { label: "Anno corrente", value: 0 },
        { label: "Personalizzato", value: null },
      ],
      sort_totale: true,
    };
  },
  computed: {
    ts_inizio() {
      if (this.periodo_preset !== null) {
        const jan1 = moment().startOf("year");
        if (this.periodo_preset === 0) return jan1.format("X");
        const subtracted = moment().subtract(this.periodo_preset, "days").startOf("day");
        return moment.max(subtracted, jan1).format("X");
      }
      return this.data_inizio
        ? moment(this.data_inizio).startOf("day").format("X")
        : null;
    },
    ts_fine() {
      if (this.periodo_preset !== null) {
        return moment().format("X");
      }
      return this.data_fine
        ? moment(this.data_fine).endOf("day").format("X")
        : null;
    },
    anni_confronto() {
      const y = moment().year();
      return [y - 1, y - 2, y - 3, y - 4].map((year) => ({
        label: String(year),
        value: year,
      }));
    },
    ricerca_invalida() {
      if (!this.ricerca) return false;
      try {
        new RegExp(this.ricerca, "i");
        return false;
      } catch {
        return true;
      }
    },
    lista_filtrata() {
      if (!this.ricerca || this.ricerca_invalida) return this.lista;
      const re = new RegExp(this.ricerca, "i");
      return this.lista.filter((el) => {
        const prodotto = this.$store.getters.get_prodotto_by_id(el.id);
        const nome = prodotto ? prodotto.nome : "";
        return re.test(nome);
      });
    },
    confronto_qta_map() {
      const raw = this.$store.getters.get_prodotti_venduti_confronto;
      const map = {};
      raw.forEach((e) => {
        const id = e.id_prodotto;
        map[id] = (map[id] || 0) + (e.qta || 0);
      });
      return map;
    },
    lista_per_sottocategoria() {
      const groups = new Map();
      this.lista_filtrata.forEach((el) => {
        const info = this.$store.getters.get_categoria_prodotto_by_id(el.id);
        const categoria = info ? info.categoria : "Altro";
        const sotto_categoria = info ? info.sotto_categoria : "Altro";
        const key = `${categoria}||${sotto_categoria}`;
        if (!groups.has(key)) {
          groups.set(key, { categoria, sotto_categoria, prodotti: [] });
        }
        groups.get(key).prodotti.push(el);
      });
      return Array.from(groups.values()).map((g) => {
        const qta_tot = g.prodotti.reduce((s, el) => s + el.qta_verde + el.qta_blu, 0);
        const qta_rif = g.prodotti.reduce((s, el) => s + (this.confronto_qta_map[el.id] || 0), 0);
        const variazione = qta_rif ? (((qta_tot - qta_rif) / qta_rif) * 100).toFixed(0) : null;
        return { ...g, qta_tot, qta_rif, variazione };
      });
    },
    lista() {
      const raw = this.$store.getters.get_prodotti_venduti;
      const byArt = _.groupBy(raw, "id_prodotto");
      return Object.entries(byArt)
        .map(([id, entries]) => {
          const qta_verde = entries
            .filter((e) => e.verde)
            .reduce((s, e) => s + (e.qta || 0), 0);
          const qta_blu = entries
            .filter((e) => !e.verde)
            .reduce((s, e) => s + (e.qta || 0), 0);
          return {
            id,
            qta_verde,
            qta_blu,
            n_doc: entries.length,
            colori_agg: [],
          };
        })
        .sort((a, b) => b.qta_blu + b.qta_verde - (a.qta_blu + a.qta_verde));
    },
  },
  methods: {
    onPeriodoChange() {
      this.fetch_prodotti();
      if (this.show_confronta) this.fetch_prodotti_confronto();
    },
    fetch_prodotti() {
      if (!this.ts_inizio || !this.ts_fine) return;
      this.loading = true;
      this.$store
        .dispatch("fetch_prodotti_venduti", {
          ts_inizio: this.ts_inizio,
          ts_fine: this.ts_fine,
        })
        .finally(() => {
          this.loading = false;
        });
    },
    fetch_prodotti_confronto() {
      if (!this.ts_inizio || !this.ts_fine) return;
      const delta = moment().year() - this.anno_confronto;
      this.loading_confronto = true;
      this.$store
        .dispatch("fetch_prodotti_venduti_confronto", {
          ts_inizio: moment
            .unix(this.ts_inizio)
            .subtract(delta, "year")
            .format("X"),
          ts_fine: moment
            .unix(this.ts_fine)
            .subtract(delta, "year")
            .format("X"),
        })
        .finally(() => {
          this.loading_confronto = false;
        });
    },
    apriDettaglio(element) {
      this.prodotto_selezionato = element;
      this.dialog_dettaglio = true;
    },
  },
};
</script>

<style scoped>
::-webkit-scrollbar {
  width: 2px;
}
::-webkit-scrollbar-track {
  background: #f1f1f1;
}
::-webkit-scrollbar-thumb {
  background: #bbbbbb;
}
.scroll {
  height: 320px;
  overflow-y: scroll;
}
</style>